// Texty analytiky vyhledávání (searchAnalytics.js). Pozor: `service` /
// `interaction` / `result_type` apod. jsou pevná hodnotová vokabuláře ve
// tvaru Luigi's Boxu (LB) a NEPŘEKLÁDAJÍ SE — zůstávají natvrdo v modulu.
// `listName` je jen čitelný GA4 `item_list_name`, ten lokalizovat smí.
export default {
  listName: 'Vyhledávání',
};
